export const GET_CONFIG = "GET_CONFIG";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS";
export const GET_CONFIG_FAILURE = "GET_CONFIG_FAILURE";

export const GET_CONFIG_SYS = "GET_CONFIG_SYS";
export const GET_CONFIG_SYS_SUCCESS = "GET_CONFIG_SYS_SUCCESS";
export const GET_CONFIG_SYS_FAILURE = "GET_CONFIG_SYS_FAILURE";


export const GET_CONFIG_SYS_LOAI_TAI_SAN = "GET_CONFIG_SYS_LOAI_TAI_SAN";
export const GET_CONFIG_SYS_LOAI_TAI_SAN_SUCCESS = "GET_CONFIG_SYS_LOAI_TAI_SAN_SUCCESS";
export const GET_CONFIG_SYS_LOAI_TAI_SAN_FAILURE = "GET_CONFIG_SYS_LOAI_TAI_SAN_FAILURE";
